import * as React from 'react';

import * as emptyDataImage from '../../assets/image/emptyData.png';

import './style.scss';

interface Props {
  message: string;
  bigImageForTab?: boolean;
}

const EmptyData = (props: Props) => {
  return(
    <section className='empty-data d-flex align-center justify-center flex-column'>
      <img
        style={props.bigImageForTab ? { width: '54px', height: '53px' } : null}
        src={emptyDataImage}
        className='empty-data-image' />
      <p
        style={props.bigImageForTab ? { fontSize: '24px', lineHeight: '36px' } : null}
        className='empty-data-message text-center'>{props.message}</p>
    </section>
  );
};

export default EmptyData;
